import request from "./requestConfig";

const apiList = {
  //用户名密码登录
  login(data) {
    return request({
      url: "/user/login",
      method: "post",
      data,
    });
  },
  //获取微信登录二维码内容 ，根据内容生成二维码
  getWxQrCodeContent(data) {
    return request({
      url: "/v2/wechat/login/qrcode",
      method: "get",
      data,
    });
  },
  //微信登录接口  需要轮询,成功之后进入系统
  wxLogin(data) {
    return request({
      url: "/v2/wechat/login",
      method: "get",
      data,
    });
  },
  getWorkBench() {
    return request({
      url: "/v2/users/work-bench",
      method: "get",
    });
  },
  // 获取版本信息
  getAppVersion() {
    return request({
      url: "/v2/applications/versions",
      method: "get",
    });
  },
  //获取微信系统配置
  getSystemWxConfig() {
    return request({
      url: "/v2/configs/system/wechatSwitch",
      method: "get",
    });
  },
  //获取google系统配置
  getSystemGoogleConfig() {
    return request({
      url: "/v2/configs/system/userLoginGoogle",
      method: "get",
    });
  },

  //Google登录
  googleLogin(data) {
    return request({
      url: "/v2/google",
      method: "get",
      data,
    });
  },

  // 获取二维码内容
  getGoogleQrCodeContent(data) {
    return request({
      url: "/v2/google/secret",
      method: "get",
      data,
    });
  },

  // google绑定
  googleBind(data) {
    return request({
      url: "/v2/google",
      method: "post",
      data,
    });
  },
  //登出接口
  logout() {
    return request({
      url: "/user/logout",
      method: "get",
    });
  },

  //根据配置名称获取某配置
  getConfigByName(config) {
    return request({
      url: `/v2/configs/system/${config}`,
      method: "get",
    });
  },

  // 获取所有语言
  getLanguageList() {
    return request({
      url: "/v2/i18n",
      method: "get",
    });
  },
};

export default apiList;
